const rankingItems = [
  {
    rank: 1,
    title: '某顶流被曝隐婚生子，孩子已三岁',
    heat: '986.5万',
    trend: 'up',
    tag: '爆',
  },
  {
    rank: 2,
    title: '知名导演新片涉嫌抄袭，海外片方发律师函',
    heat: '872.3万',
    trend: 'up',
    tag: '热',
  },
  {
    rank: 3,
    title: '某综艺节目录制现场嘉宾冲突视频流出',
    heat: '765.8万',
    trend: 'up',
    tag: '热',
  },
  {
    rank: 4,
    title: '某女星深夜发长文疑似回应近期绯闻',
    heat: '654.2万',
    trend: 'down',
    tag: '',
  },
  {
    rank: 5,
    title: '某国际品牌代言人突然解约引发多方猜测',
    heat: '543.6万',
    trend: 'up',
    tag: '',
  },
  {
    rank: 6,
    title: '某男星被拍到与神秘女子深夜同行回家',
    heat: '432.1万',
    trend: 'up',
    tag: '',
  },
  {
    rank: 7,
    title: '某知名网红自曝被经纪公司欺压多年',
    heat: '387.9万',
    trend: 'new',
    tag: '新',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">吃瓜热度榜</h2>
          <p className="text-sm text-foreground-500">实时追踪全网最热吃瓜话题</p>
        </div>

        <div className="bg-background-100 rounded-lg overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 transition-colors duration-200 hover:bg-background-200/70 cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-md flex items-center justify-center text-sm font-bold flex-shrink-0 whitespace-nowrap ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
              </div>

              {item.tag && (
                <span className={`px-2 py-0.5 rounded text-xs font-semibold flex-shrink-0 whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              )}

              <div className="flex items-center gap-1 flex-shrink-0 whitespace-nowrap">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-secondary-500 text-sm"></i>}
                {item.trend === 'new' && <i className="ri-add-circle-line text-accent-500 text-sm"></i>}
                <span className="text-xs text-foreground-500">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}